var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatesOverlapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(2 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M0,155.922A4.945,4.945,0,1,0,4.969,151,4.968,4.968,0,0,0,0,155.922Zm0,0",
    transform: "translate(0 -143.922)",
    fill: "#545961",
    stroke: "#545961",
    strokeWidth: 4,
    strokeDasharray: "1 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M308.031,152.172a2.8,2.8,0,0,1-2.286-4.438l1-1.406-1.7.306a4.917,4.917,0,0,0,.875,9.757,4.734,4.734,0,0,0,4.663-4.047l.306-1.7-1.406,1a2.3,2.3,0,0,1-1.454.526Zm0,0",
    transform: "translate(-284.891 -139.469)",
    fill: "#545961"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M121.032,387.833l-.985-1a9.152,9.152,0,0,1-10.684,1.524l2.167-.58-.364-1.358-4.522,1.211,1.212,4.676,1.358-.364-.6-2.382a10.529,10.529,0,0,0,12.414-1.722Zm0,0",
    transform: "translate(-101.644 -364.301)",
    fill: "#545961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M108.292,5.887l4.522-1.211L111.6,0l-1.358.364.6,2.387A10.568,10.568,0,0,0,98.426,4.468l.985,1a9.156,9.156,0,0,1,10.684-1.524l-2.167.58Zm0,0",
    transform: "translate(-93.426)",
    fill: "#545961"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatesOverlapping);
export default __webpack_public_path__ + "static/media/datesOverlapping.294283b1c6c8c825580003bb1cd2225a.svg";
export { ForwardRef as ReactComponent };